import { render } from "./NewVideoPage.vue?vue&type=template&id=32fe3fb1&scoped=true"
import script from "./NewVideoPage.vue?vue&type=script&lang=js"
export * from "./NewVideoPage.vue?vue&type=script&lang=js"

import "./NewVideoPage.vue?vue&type=style&index=0&id=32fe3fb1&scoped=scoped&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fe3fb1"]])

export default __exports__